import Cookies from 'js-cookie'
import axios from 'axios';
import config from '@/configure/index'
// Cookies.set('name', 'value', { path: '' })
// Cookies.get('name') // => 'value'
// Cookies.remove('name', { path: '' })

export const authCreate = async() => {
    // Cookies.set(config.adminPath+'_token', process.env.ACCESS_TOKEN)
    if (process.env.NODE_ENV == 'production') {
        Cookies.set(config.adminPath + '_token', 'MQ5xXXHH0aVtjxNTmkvD88Ve7chwvZOMdVfCnngE')
    } else {

        const params = {
            email: process.env.EMAIL,
            password: process.env.PASSWORD
        };

        const data = Object.keys(params)
            .map((key) => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');


        const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data,
            url: `${config.apiBaseUrl}/service/login`,
        };
        const response = await axios(options); // wrap in async function
        Cookies.set(config.adminPath + '_token', response.data.token)
        return response.data.token;
    }
}

export const authRead = () => {
    //if(process.env.NODE_ENV == 'production'){
    // return '9VmUemnyL4esEAA91WLnwFXoMKTh3iiJWRZI2NeE';
    // }else{
        return process.env.ACCESS_TOKEN;
    // }
}


// WEBPACK FOOTER //
// ./src/store/auth.js